import { Text, View } from "react-native";
import { AddIcon, Icon } from "ui/gluestack/icon";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { useState } from "react";
import { CreateEditRoleModal } from "../../CreateEditRoleModal";
import { useGetAllRolesQuery } from "app/services/api/rolesApi";
import TableList from "app/components/organisms/TableList";
import { ColumnModel } from "app/services/api/types/common/models/ColumnModel";
import { RoleModel } from "app/services/api/types/roles/models/RoleModel";
import { RoleContent } from "../organisms/RoleContent";
import { RoleActions } from "../organisms/RoleActions";
import CardItem from "app/components/organisms/CardItem";
import { DeleteRoleUserModal } from "../../DeleteRoleUserModal";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { Portal } from "ui/modules/ThrelsPortal/Portal";

export default function RolesListTemplate() {
  const { data, isLoading, refetch } = useGetAllRolesQuery(undefined);

  const [isModalVisible, setModalVisible] = useState(false);
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);

  const toggleModal = () => {
    setEditRole(undefined);
    setModalVisible((prevState) => !prevState);
  };

  const handleSuccess = () => {
    setModalVisible(!isModalVisible);
    refetch();
  };
  const startEditRole = (role: RoleModel) => {
    setEditRole(role);
    setModalVisible((prevState) => !prevState);
  };

  const [editRole, setEditRole] = useState<RoleModel | undefined>(undefined);
  const [deleteRole, setDeleteRole] = useState<RoleModel | undefined>(
    undefined,
  );

  const startDeleteRole = (role: RoleModel) => {
    setDeleteRole(role);
    setDeleteModalVisible(true);
  };

  const handleDeleteSuccess = () => {
    setDeleteModalVisible(false);
    refetch();
  };

  const columns: ColumnModel<RoleModel>[] = [
    {
      title: "Roles",
      dataKey: "display_name",
      renderCell: (role: RoleModel) => (
        <View className="flex flex-row items-center">
          <Text className="font-medium text-base">{role.display_name}</Text>
        </View>
      ),
    },
    {
      title: "Role Manager",
      dataKey: "parent",
      renderCell: (role: RoleModel) => (
        <View className="flex flex-row items-center">
          <Text>{role.parent?.display_name}</Text>
        </View>
      ),
    },
    {
      title: undefined,
      dataKey: "permissions",
      renderCell: (role: RoleModel) => (
        <RoleActions
          role={role}
          onEdit={startEditRole}
          onDelete={startDeleteRole}
        />
      ),
    },
  ];
  return (
    <View className="flex-1 bg-white">
      <CreateEditRoleModal
        isVisible={isModalVisible}
        onClose={() => setModalVisible(!isModalVisible)}
        onSuccess={handleSuccess}
        initialRole={editRole}
      />
      <DeleteRoleUserModal
        isVisible={isDeleteModalVisible}
        onClose={() => setDeleteModalVisible(false)}
        role={deleteRole}
        onSuccess={handleDeleteSuccess}
      />
      <Portal hostName="headerButton" identifier="rolesList">
        <PermissionCheck permission={PermissionsEnums.CREATE_ROLE}>
          <Button
            action="primary"
            size="sm"
            onPress={toggleModal}
            className="mb-3"
          >
            <ButtonText>Create new role</ButtonText>
            <ButtonIcon as={AddIcon} className="w-4 h-4" />
          </Button>
        </PermissionCheck>
      </Portal>
      <TableList
        columns={columns}
        data={data}
        columnSpanClass="col-span-4"
        isFetching={isLoading}
        emptyMessage="No roles available."
        mobileRenderItem={(item) => (
          <CardItem
            key={item.id}
            actionButtons={
              <RoleActions
                role={item}
                onEdit={startEditRole}
                onDelete={startDeleteRole}
              />
            }
            cardContent={<RoleContent role={item} />}
          />
        )}
      />
    </View>
  );
}
